import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import Div from "@jumbo/shared/Div";
import { Field, Form, Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import { FormControlLabel, Switch } from "@mui/material";

const ScreenSettings = ({
  settings: { screenName, screenWidth, screenHeight, rotateScreen },
  children,
}) => {
  const { t } = useTranslation();

  return (
    <Formik
      validateOnChange={true}
      initialValues={{ screenName, screenWidth, screenHeight, rotateScreen }}
      onSubmit={async (data, { setSubmitting }) => {
        setSubmitting(true);
        // await onReset(data.email);
        setSubmitting(false);
      }}
    >
      <Form style={{ textAlign: "left" }} noValidate>
        <Div sx={{ mt: 2, mb: 1, mx: 2 }}>
          <JumboTextField
            fullWidth
            name="screenName"
            label={t("pages.presentation.label")}
          />
        </Div>
        <Div sx={{ mt: 2, mb: 1, mx: 2 }}>
          <JumboTextField
            fullWidth
            type="number"
            name="screenWidth"
            label={t("pages.presentation.width")}
          />
        </Div>
        <Div sx={{ mt: 2, mb: 1, mx: 2 }}>
          <JumboTextField
            fullWidth
            type="number"
            name="screenHeight"
            label={t("pages.presentation.height")}
          />
        </Div>
        <Div sx={{ mt: 2, mb: 1, mx: 2 }}>
          <FormControlLabel
            control={
              <Field name="rotateScreen">
                {({ field, form }) => (
                  <Switch
                    name={field.name}
                    color="primary"
                    sx={{ mr: 1 }}
                    checked={!!field.value}
                    onChange={(e) =>
                      form.setFieldValue(field.name, e.target.checked)
                    }
                  />
                )}
              </Field>
            }
            label={t("pages.presentation.rotateScreen")}
          />
        </Div>
        {children}
      </Form>
    </Formik>
  );
};

export default ScreenSettings;
